export const vehicleEnergyMapping = new Map([
  ['ESSENCE', 'ESSENCE'],
  ['DIESEL', 'DIESEL'],
  ['BICARBURATION_ESSENCE_GPL', 'GPL'],
  ['ELECTRIQUE', 'ÉLECTRIQUE'],
  ['HYBRIDE_DIESEL_ELECTRIQUE', 'HYBRIDE DIESEL ÉLECTRIQUE'],
  ['HYBRIDE_ESSENCE_ELECTRIQUE', 'HYBRIDE ESSENCE ÉLECTRIQUE'],
  ['BICARBURATION_ESSENCE_GNV', 'GNV'],
  ['BICARBURATION_ESSENCE_BIOETHANOL', 'ÉTHANOL'],
]);
